import { useState, useEffect } from 'react';

const announcements = [
  'Free style consultation on WhatsApp',
  'Sweat-proof. Water-resistant. Life-Proof Gold.',
  'Free shipping on orders above ₹1,499',
  'New arrivals dropping every Friday',
];

export default function AnnouncementBar() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % announcements.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="bg-accent-500 text-primary-800 py-2 overflow-hidden">
      <div className="max-w-none mx-auto px-4">
        <div className="relative h-5 flex items-center justify-center">
          {announcements.map((text, i) => (
            <p
              key={i}
              className={`absolute text-xs md:text-sm font-label font-medium tracking-wide whitespace-nowrap transition-all duration-500 ${
                i === current
                  ? 'opacity-100 translate-y-0'
                  : 'opacity-0 -translate-y-4'
              }`}
            >
              {text}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
}